export default __webpack_public_path__ + "static/media/office1-after2-1920w.2c69b3a3.avif";